import { Component, Input, OnChanges } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { KPI } from '../../../@core/api';


@Component({
  selector: 'app-history-changes-list',
  styleUrls: ['./history-changes-list.component.scss'],
  templateUrl: './history-changes-list.component.html',
  standalone: true,
  imports: [
    TranslateModule
  ],
})
export class HistoryChangesListComponent implements OnChanges {
  @Input() public changes: KPI.ChangeItem[];

  public ngOnChanges(): void {
  }
}
